// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPagePL = {
  seo: {
    title: 'Przejrzystość w zakresie AI | pAIoneer Labs GmbH',
    description: 'Jak pAIoneer Labs GmbH wykorzystuje sztuczną inteligencję i informuje o tym: asystent AI, oznaczanie treści wygenerowanych przez AI, odpowiedzialność redakcyjna i punkt kontaktowy zgodnie z aktem w sprawie sztucznej inteligencji.',
    keywords: 'przejrzystość w zakresie AI, akt w sprawie sztucznej inteligencji, AI Act, art.\u00a050, oznaczanie, asystent AI, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Przejrzystość w zakresie AI',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Przejrzystość w zakresie AI',
    subtitle: 'Jak pAIoneer Labs GmbH wykorzystuje sztuczną inteligencję i informuje o tym.'
  },
  sections: [
    {
      title: 'Ramy prawne',
      paragraphs: [
        'Od 2 sierpnia 2026 mają zastosowanie obowiązki w zakresie przejrzystości określone w art.\u00a050 rozporządzenia (UE) 2024/1689 w sprawie sztucznej inteligencji (akt w sprawie sztucznej inteligencji). W Niemczech na podstawie KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, niemiecka ustawa o nadzorze rynku AI i wspieraniu innowacji) Bundesnetzagentur (niemiecka Federalna Agencja Sieci) jest organem nadzoru rynku i organem rozpatrującym skargi w zakresie aktu w sprawie sztucznej inteligencji.',
        'Ta strona opisuje, jakie systemy AI wykorzystuje pAIoneer Labs GmbH i w jaki sposób o nich informuje. Sposób, w jaki przetwarzane są przy tym dane osobowe, opisuje polityka prywatności.'
      ]
    },
    {
      title: 'Asystent AI w naszej aplikacji',
      paragraphs: [
        'W naszej aplikacji na Twoje pytania odpowiada asystent AI. Jest on systemem AI: jego odpowiedzi są generowane automatycznie przez modele językowe i mogą być błędne. Sprawdzaj ważne informacje, zanim oprzesz na nich decyzje.',
        'Aplikacja informuje Cię o tym przed Twoim pierwszym wpisem i stale obok czatu (art.\u00a050 ust.\u00a01 aktu w sprawie sztucznej inteligencji). Ponadto każda odpowiedź asystenta jest oznaczona w formacie nadającym się do odczytu maszynowego jako wygenerowana przez AI (art.\u00a050 ust.\u00a02 aktu w sprawie sztucznej inteligencji).',
        'Modele językowe są udostępniane za pośrednictwem usługi OpenRouter, Inc., USA.'
      ]
    },
    {
      title: 'Bezpośrednia komunikacja z systemami AI',
      paragraphs: [
        'Jeżeli system AI pAIoneer Labs GmbH komunikuje się bezpośrednio z Tobą, na przykład na czacie, ujawnia, że jest systemem AI, najpóźniej przy pierwszej interakcji.'
      ]
    },
    {
      title: 'Treści tej strony internetowej',
      paragraphs: [
        'Teksty tej strony internetowej są – również tam, gdzie narzędzia AI wspierają ich tworzenie – sprawdzane przez pAIoneer Labs GmbH i publikowane w ramach jej odpowiedzialności redakcyjnej (art.\u00a050 ust.\u00a04 akapit drugi aktu w sprawie sztucznej inteligencji).',
        'Treści graficzne, dźwiękowe lub wideo, które zostały wygenerowane lub zmienione przy użyciu AI i w zwodniczo realistyczny sposób przedstawiają rzeczywiste osoby, miejsca lub wydarzenia, oznaczamy jako sztucznie wygenerowane lub zmienione (art.\u00a050 ust.\u00a04 akapit pierwszy aktu w sprawie sztucznej inteligencji).'
      ]
    },
    {
      title: 'Analiza z wykorzystaniem uczenia maszynowego',
      paragraphs: [
        'Za Twoją zgodą analizujemy statystyki odwiedzin metodami uczenia maszynowego; szczegóły zawiera polityka prywatności. Nie stosujemy przy tym ani rozpoznawania emocji, ani kategoryzacji biometrycznej (art.\u00a050 ust.\u00a03 aktu w sprawie sztucznej inteligencji). Rozróżnienie między ludźmi a dostępem zautomatyzowanym opiera się na cechach technicznych urządzenia, przeglądarki i połączenia, a nie na danych biometrycznych.'
      ]
    },
    {
      title: 'Skarga',
      paragraphs: [
        'Ze skargą dotyczącą możliwego naruszenia aktu w sprawie sztucznej inteligencji możesz zwrócić się do Bundesnetzagentur, organu nadzoru rynku i organu rozpatrującego skargi w zakresie aktu w sprawie sztucznej inteligencji w Niemczech. Informacje na ten temat Bundesnetzagentur udostępnia pod adresem bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Kontakt',
    description: 'Z pytaniami dotyczącymi wykorzystania sztucznej inteligencji możesz skontaktować się z nami e-mailem.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Stan na: 30 października 2026. Wiążąca jest wersja niemiecka.'
};
